<form #formulario="ngForm">
        <mat-accordion>
    
            <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
                <mat-expansion-panel-header>
                    <mat-panel-title>Dados do Colaborador</mat-panel-title>
                </mat-expansion-panel-header>
    
                <div fxLayout="row" style="margin-top: 10px; margin-bottom: 10px" >
                    
                    <mat-form-field fxFlex="45%" fxFlexOffset="20px">
                        <mat-label>Funcionário:</mat-label>
                        <mat-select [(ngModel)]="colaboradoresPrograma.funcionario.id" name="unidade" required>
                            <mat-option></mat-option>
                            <mat-option *ngFor="let m of funcionarios" [value]="m.id">
                                {{m.nome}}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="funcionarios?.length === 0" align="start">Nenhum funcionário cadastrado</mat-hint>
                    </mat-form-field>

                    <mat-form-field fxFlex="45%" fxFlexOffset="20px">
                        <mat-label>Cargo:</mat-label>
                        <mat-select [(ngModel)]="colaboradoresPrograma.cargo.id" name="cargo" required (selectionChange)="verificaComposicaoCargo()">
                            <mat-option></mat-option>
                            <mat-option *ngFor="let m of cargos" [value]="m.id">
                                {{m.nome}}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="cargos?.length === 0" align="start">Nenhum cargo cadastrado</mat-hint>
                    </mat-form-field>

                </div>

                <div fxLayout="row" style="margin-top: 10px; margin-bottom: 10px">
                    
                    <mat-form-field fxFlex="45%" fxFlexOffset="20px">
                        <mat-label>Tipo Contratação:</mat-label>
                        <mat-select [(ngModel)]="colaboradoresPrograma.tiposContratacoes.id" name="tiposContratacoes">
                            <mat-option></mat-option>
                            <mat-option *ngFor="let m of listaTiposContratacoes" [value]="m.id">
                                {{m.descricaoTipoContratacao}}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="listaTiposContratacoes?.length === 0" align="start">Nenhum tipo contratação cadastrado</mat-hint>
                    </mat-form-field>
                    
                    <mat-form-field fxFlex="20%" fxFlexOffset="20px">
                        <input matInput name= "dtImplantacao" [matDatepicker]="dataInicio" placeholder="Data de entrada:" [(ngModel)]="colaboradoresPrograma.dataInicio" required>
                        <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                        <mat-datepicker #dataInicio></mat-datepicker>
                    </mat-form-field>
    
                    <mat-form-field fxFlex="20%" fxFlexOffset="20px">
                        <input matInput name= "dtTermino" [matDatepicker]="dataTermino" placeholder="Data de saída:" [(ngModel)]="colaboradoresPrograma.dataFim">
                        <mat-datepicker-toggle matSuffix [for]="dataTermino"></mat-datepicker-toggle>
                        <mat-datepicker #dataTermino></mat-datepicker>
                    </mat-form-field>
                </div>
    
                <div fxLayout="row" style="margin-top: 10px; margin-bottom: 10px">
                    <mat-form-field fxFlex="45%" fxFlexOffset="20px">
                        <input matInput type="number" maxlength="3" name="percentual"
                            placeholder="Valor em Percentual de participação"
                            [(ngModel)]="colaboradoresPrograma.percentual">
                    </mat-form-field>
                </div>
    
                
                <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                    style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
    
                    <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                        Limpar
                    </button>
    
                    <button *ngIf="!isAtualizar"  mat-raised-button name="botaoAdicionar" [disabled]=formulario.invalid  fxFlex="20%" color="primary" (click)="adicionar()">
                        Adicionar
                    </button>

                    <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" [disabled]=formulario.invalid  fxFlex="20%" color="primary" (click)="atualizar()">
                        Atualizar
                    </button>
    
                </div>
    
            </mat-expansion-panel>
    
    
            <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
                (closed)="openFormCadastro = true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Lista de Colaboradores ( {{listaColaboradoresPrograma?.length}} )
                    </mat-panel-title>
                </mat-expansion-panel-header>
    
                <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                    style="margin-top: 20px">
    
                    <ng-container matColumnDef="nome">
                        <th mat-header-cell *matHeaderCellDef> Nome </th>
                        <td mat-cell *matCellDef="let element"> {{element.funcionario.pessoasFisica.nome}} </td>
                    </ng-container>
    
                    <ng-container matColumnDef="cpf">
                        <th mat-header-cell *matHeaderCellDef> CPF </th>
                        <td mat-cell *matCellDef="let element"> {{element.funcionario.pessoasFisica.cpf}} </td>
                    </ng-container>
    
                    <ng-container matColumnDef="cargo">
                        <th mat-header-cell *matHeaderCellDef> Cargo</th>
                        <td mat-cell *matCellDef="let element"> {{element.cargo.nome}} </td>
                    </ng-container>
    
                    <ng-container matColumnDef="acoes">
                        <th mat-header-cell *matHeaderCellDef > Ações </th>
                        <td mat-cell *matCellDef="let element">
                            <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(element)">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizarColaborador(element)">
                                <mat-icon>create</mat-icon>
                            </button>
                        </td>
                    </ng-container>
    
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
    
                <div [hidden]="!mostrarTabela">
                    <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
                </div>
    
                <ng-template #tabelaSemDados>
                    <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                        {{msg}}
                    </div>
                </ng-template>
    
                <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
                    style="padding-top: 30px">
                    <div>
                        <button matTooltip="Adicionar novo colaborador" mat-fab color="primary" (click)="novo()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>
    
    
            </mat-expansion-panel>
    
        </mat-accordion>
    </form>
